
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Component from 'vue-class-component';
import Heading from '@components/base/Heading.vue';
import RichText from '@components/003-RichText/RichText.vue';
import ButtonComponent from '@components/004-ButtonComponent/ButtonComponent.vue';
import AbstractRaffle from '@modules/053-Raffle/AbstractRaffle.vue';

@Component({
	components: {
		Heading,
		RichText,
		ButtonComponent
	}
})
export default class AbstractStep extends Vue {
	@Prop(String)
	protected readonly headline!: string;

	@Prop(Number)
	protected readonly headlineLevel?: number;

	@Prop(String)
	protected readonly copy?: string;

	@Prop(String)
	protected readonly buttonLabel?: string;

	@Prop(String)
	protected readonly primaryBackgroundColor?: string;

	protected onButtonClick() {
		this.$emit('click');
	}

	protected mounted() {
		(this.$parent as AbstractRaffle<any>).removeHeightOnWrapper();
	}
}
